/** Available reward types. */
export var RewardType;
(function (RewardType) {
    /** Undefined reward type. */
    RewardType["UNDEFINED"] = "UNDEFINED";
    /** Discount reward. Special flexible reward type used in checkout. */
    RewardType["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    /** Coupon reward. [Learn more about coupons](https://support.wix.com/en/article/using-coupons-as-loyalty-rewards). */
    RewardType["COUPON_REWARD"] = "COUPON_REWARD";
    /** For internal use. */
    RewardType["SPI_DISCOUNT_AMOUNT"] = "SPI_DISCOUNT_AMOUNT";
})(RewardType || (RewardType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map